<template>
  <span
    >[{{ action.guestContactType }}]
    {{ actionStyling[action._type].description }} '{{
      action.message.substring(0, 30)
    }}'</span
  >
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["action"],
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapGetters({
      actionStyling: "automations/actionStyling",
    }),
  },
  async mounted() {},
};
</script>

<style lang="scss">
</style>